module.exports = __webpack_public_path__ + "img/laboratory-clinic.341d5fa4.jpg";